import * as Config from '../../../data.json';

const AboutSpec = {
  label: '關於我們',
  label__en: 'About',
  label__jp: '当会について',
  key: '',
  key__en: '',
  key__jp: '',
  children: [
    {
      path: '',
      path__en: '',
      path__jp: '',
      label: '公會簡介',
      label__en: 'Introduction',
      label__jp: '当会について',
      children: [
        {
          key: '/about?group=introduction&category=history',
          key__en: '/eng-track',
          key__jp: '/japan-history',
          label: '軌跡-歷史沿革',
          label__en: 'Track-History',
          label__jp: '軌跡-あゆみと歴史',
          children: [],
        },
        {
          key: '/about?group=introduction&category=team',
          key__en: '/eng-team',
          key__jp: '/japan-team',
          label: '團隊-組織架構',
          label__en: 'Team-Organization',
          label__jp: '組織',
          children: [],
        },
        {
          key: '/about?group=introduction&category=thinking',
          key__en: '/eng-philosophy',
          key__jp: '/japan-philosophy',
          label: '思維-使命理念',
          label__en: 'Philosophy-Mission Statement',
          label__jp: '構想-使命と理念',
          children: [],
        },
        {
          key: '/about?group=introduction&category=opposition',
          key__en: '/eng-voice',
          key__jp: '/japan-voice',
          label: '在野-改革參與',
          label__en: 'Voices-Participation in Reforms',
          label__jp: '改革への参加',
          children: [],
        },
        {
          key: '/about?group=introduction&category=overview',
          key__en: '/eng-vision',
          key__jp: '/japan-vision',
          label: '視野-國際交流',
          label__en: 'Vision-International Exchange',
          label__jp: '国際交流',
          children: [],
        },
        {
          key: '/about?group=introduction&category=personnel',
          key__en: '',
          key__jp: '',
          label: '公會歷屆監理事',
          label__en: 'Directors and Supervisors List',
          label__jp: '歴代役員一覧',
          children: [],
        },
        {
          key: '/about?group=introduction&category=contact',
          key__en: '/eng-contact',
          key__jp: '/japan-contact',
          label: '聯絡方式',
          label__en: 'Contact',
          label__jp: 'お問い合わせ窓口',
          children: [],
        },
      ],
    },
    {
      key: '',
      key__en: '',
      key__jp: '',
      label: '公會規章',
      label__en: 'Regulations',
      label__jp: '当会の規則',
      children: [
        {
          key: '/about?group=regulation&category=association',
          key__en: '',
          key__jp: '',
          label: '會務相關法規',
          label__en: 'General Affairs Regulations',
          label__jp: '会務関連規則',
          children: [],
        },
        {
          key: '/about?group=regulation&category=business',
          key__en: '',
          key__jp: '',
          label: '業務相關法規',
          label__en: 'Administration Regulations',
          label__jp: '業務関連規則',
          children: [],
        },
        {
          key: '/about?group=regulation&category=practicing',
          key__en: '',
          key__jp: '',
          label: '律師執業相關法規',
          label__en: 'Legal Practice Regulations',
          label__jp: '弁護士業務関連規則',
          children: [],
        },
        {
          key: '/about?group=regulation&category=morale',
          key__en: '',
          key__jp: '',
          label: '律師倫理案例選輯',
          label__en: 'Lawyer Ethics Cases',
          label__jp: '弁護士倫理事件例',
          children: [],
        },
      ],
    },
    {
      key: '',
      key__en: '',
      key__jp: '',
      label: '會館巡禮',
      label__en: 'Hall Tour',
      label__jp: '当会の会館',
      children: [
        {
          key: '/about?group=environment&category=pictures',
          key__en: '',
          key__jp: '',
          label: '會館寫真',
          label__en: 'Photos',
          label__jp: '会館写真',
          children: [],
        },
        {
          key: '/about?group=environment&category=operator',
          key__en: '',
          key__jp: '',
          label: '會館營運辦法',
          label__en: 'Operation Rules',
          label__jp: '会館運営規則',
          children: [],
        },
        {
          key: '/about?group=environment&category=charge',
          key__en: '',
          key__jp: '',
          label: '台北律師公會會館會議室外借須知暨收費標準',
          label__en: 'Meeting Room Rental Instructions and Fees',
          label__jp: '会館会議室レンタルのご案内と料金',
          children: [],
        },
      ],
    },
    {
      key: '',
      key__en: '',
      key__jp: '',
      label: '圖書資訊室',
      label__en: 'Library and Information Center',
      label__jp: '当会の図書館と図書情報センター',
      children: [
        {
          key: '/about?group=library&category=introduction',
          key__en: '',
          key__jp: '',
          label: '館藏介紹',
          label__en: 'Collection Introduction',
          label__jp: '所蔵資料の紹介',
          children: [],
        },
        {
          key: '/about?group=library&category=fax',
          key__en: '',
          key__jp: '',
          label: '傳真檢索',
          label__en: 'Fax Retrieval',
          label__jp: 'FAXでの検索申請',
          children: [],
        },
        {
          key: '/about?group=library&category=search',
          key__en: '',
          key__jp: '',
          label: '館藏檢索',
          label__en: 'Collection Search',
          label__jp: '所蔵資料の検索',
          children: [],
        },
        {
          key: '/about?group=library&category=university-serial',
          key__en: '',
          key__jp: '',
          label: '大學期刊檢索',
          label__en: 'University Journal Search',
          label__jp: '大学定期刊行物検索',
          children: [],
        },
        {
          key: '/about?group=library&category=borrow',
          key__en: '',
          key__jp: '',
          label: '各大學圖書館借閱方式',
          label__en: 'Borrowing methods from university libraries',
          label__jp: '各大学図書館本の借り方',
          children: [],
        },
      ],
    },
    {
      key: '/about?group=member',
      key__en: '',
      key__jp: '',
      label: '台北律師公會會員動態',
      label__en: 'Member News',
      label__jp: '会員ニュース',
      children: [],
    },
    {
      key: '/about?group=data-protection',
      key__en: '',
      key__jp: '',
      label: '個人資料保護管理政策',
      label__en: 'Personal Information Protection and Management Policy',
      label__jp: '個人情報保護管理方針',
      children: [],
    },
    {
      key: '/about?group=data-information',
      key__en: '',
      key__jp: '',
      label: '個資告知事項',
      label__en: 'Personal Information Notification Matters',
      label__jp: '個人情報告知事項',
      children: [],
    },
  ],
};

const MemberSpec = {
  label: '會員服務',
  label__en: 'Member Service',
  label__jp: '会員サービス',
  key: '',
  key__en: '',
  key__jp: '',
  children: [
    {
      key: '/member',
      key__en: '',
      key__jp: '',
      label: '會員主頁',
      label__en: 'Main Page',
      label__jp: '会員用メインページ',
      children: [],
    },
    {
      key: '/profile',
      key__en: '',
      key__jp: '',
      label: '個人資訊',
      label__en: 'Personal Information',
      label__jp: '個人情報',
      children: [],
    },
    {
      key: '/videos',
      key__en: '',
      key__jp: '',
      label: '北律雲-課程影片',
      label__en: 'TBA Cloud-Course Videos',
      label__jp: '研修ビデオ',
      children: [],
    },
    {
      key: '/live_streams',
      key__en: '',
      key__jp: '',
      label: '北律雲-直播串流',
      label__en: 'TBA Cloud-Course Live Streaming',
      label__jp: '研修のライブストリーミング',
      children: [],
    },
    {
      key: '/products?sort=-session.date',
      key__en: '',
      key__jp: '',
      label: '課程活動',
      label__en: 'Courses and Activities',
      label__jp: '研修イベント',
      children: [],
    },
  ],
};

const LawSpec = {
  label: '法律服務',
  label__en: 'Legal Service',
  label__jp: 'リーガルサービス',
  key: '',
  key__en: '',
  key__jp: '',
  children: [
    {
      key: '/law-service?group=periodicals',
      key__en: '',
      key__jp: '',
      label: '律師法學期刊',
      label__en: 'Legal Journals',
      label__jp: '弁護士法学定期刊行物',
      children: [],
    },
    {
      key: '',
      key__en: '',
      key__jp: '',
      label: '出版線上',
      label__en: 'Publications',
      label__jp: '電子出版',
      children: [
        {
          key: '/law-service?group=online&category=book',
          key__en: '',
          key__jp: '',
          label: '新書通報',
          label__en: 'New Books Announcement',
          label__jp: '新刊のお知らせ',
          children: [],
        },
        {
          key: '/law-service?group=online&category=magazine',
          key__en: '',
          key__jp: '',
          label: '會刊（在野法潮）',
          label__en: 'Journals',
          label__jp: '当会定期刊行物',
          children: [],
        },
        {
          key: '/law-service?group=online&category=publication',
          key__en: '',
          key__jp: '',
          label: '公會出版品',
          label__en: 'Publications',
          label__jp: '当会出版物',
          children: [],
        },
        {
          key: '/law-service?group=online&category=periodical',
          key__en: '',
          key__jp: '',
          label: '律師雜誌',
          label__en: 'Lawyer Magazines',
          label__jp: '弁護士雑誌',
          children: [],
        },
      ],
    },
    {
      key: '/law-service?group=internal',
      key__en: '',
      key__jp: '',
      label: '國內法律資料庫網站',
      label__en: 'Domestic Legal Search Information',
      label__jp: '国内法律情報サイト',
      children: [],
    },
    {
      key: '/law-service?group=external',
      key__en: '',
      key__jp: '',
      label: '國外法律資料庫網站',
      label__en: 'International Legal Search Information',
      label__jp: '国外法律情報サイト',
      children: [],
    },
    {
      key: '/law-service?group=search',
      key__en: '',
      key__jp: '',
      label: '法律類搜尋引擎',
      label__en: 'Legal Search Engines',
      label__jp: '法律類サーチエンジン',
      children: [],
    },
    {
      key: '',
      key__en: '',
      key__jp: '',
      label: '圖書資訊服務',
      label__en: 'Library and Information Service',
      label__jp: '図書館および情報サービス',
      children: [
        {
          key: '/law-service?group=library&category=introduction',
          key__en: '',
          key__jp: '',
          label: '館藏介紹',
          label__en: 'Collection Introduction',
          label__jp: '所蔵資料の紹介',
          children: [],
        },
        {
          key: '/law-service?group=library&category=fax',
          key__en: '',
          key__jp: '',
          label: '傳真檢索',
          label__en: 'Fax Retrieval',
          label__jp: 'FAXでの検索申請',
          children: [],
        },
        {
          key: '/law-service?group=library&category=search',
          key__en: '',
          key__jp: '',
          label: '館藏檢索',
          label__en: 'Collection Search',
          label__jp: '所蔵資料の検索',
          children: [],
        },
        {
          key: '/law-service?group=library&category=university-serial',
          key__en: '',
          key__jp: '',
          label: '大學期刊檢索',
          label__en: 'University Journal Search',
          label__jp: '大学定期刊行物検索',
          children: [],
        },
        {
          key: '/law-service?group=library&category=borrow',
          key__en: '',
          key__jp: '',
          label: '各大學圖書館借閱方式',
          label__en: 'Borrowing methods from university libraries',
          label__jp: '各大学図書館本の借り方',
          children: [],
        },
      ],
    },
    {
      key: 'https://portal.ezlawyer.com.tw/Login.do',
      key__en: '',
      key__jp: '',
      label: '司法院律師單一入口',
      label__en: 'Judicial Yuan Lawyer Single Log-in Page',
      label__jp: '司法院弁護士ワンストップ窓口',
      children: [],
    },
    {
      key: '/law-service?group=column',
      key__en: '',
      key__jp: '',
      label: '法律普及專欄',
      label__en: 'Legal Popularization Column',
      label__jp: '法律普及コラム',
      children: [],
    },
  ],
};

const PublicSpec = {
  label: '公眾服務',
  label__en: 'Public Service',
  label__jp: '社会向けサービス',
  key: '__group-public-service',
  key__en: '',
  key__jp: '',
  children: [
    {
      key: '/public-service?group=roster',
      key__en: '',
      key__jp: '',
      label: '我要找律師',
      label__en: '',
      label__jp: '弁護士を探す',
      children: [],
    },
    {
      key: '/public-service?group=brand',
      key__en: '',
      key__jp: '',
      label: '商標法事務專區',
      label__en: '',
      label__jp: '商標法事務',
      children: [],
    },
    {
      key: '',
      key__en: '',
      key__jp: '',
      label: '社會參與',
      label__en: 'Social Participation',
      label__jp: '社会参加',
      children: [
        {
          key: '/public-service?group=society&category=human-rights',
          key__en: '',
          key__jp: '',
          label: '人權委員會',
          label__en: 'Human Rights Committee',
          label__jp: '人権委員会',
          children: [],
        },
        {
          key: '/public-service?group=society&category=law-helper',
          key__en: '',
          key__jp: '',
          label: '法律扶助委員會',
          label__en: 'Legal Aid Committee',
          label__jp: '法律扶助委員会',
          children: [],
        },
        {
          key: '/public-service?group=society&category=judicial-reform',
          key__en: '',
          key__jp: '',
          label: '司法改革委員會',
          label__en: 'Judicial Reform Committee',
          label__jp: '司法改革委員会',
          children: [],
        },
        {
          key: '/public-service?group=society&category=law-education',
          key__en: '',
          key__jp: '',
          label: '法治教育委員會',
          label__en: 'Legal Education Committee',
          label__jp: '法治教育委員会',
          children: [],
        },
        {
          key: '/public-service?group=society&category=environmental-law',
          key__en: '',
          key__jp: '',
          label: '環境法委員會',
          label__en: 'Environmental Law Committee',
          label__jp: '環境法委員会',
          children: [],
        },
        {
          key: '/public-service?group=society&category=family-law',
          key__en: '',
          key__jp: '',
          label: '家事法委員會',
          label__en: 'Family Law Committee',
          label__jp: '家事法委員会',
          children: [],
        },
        {
          key: '/public-service?group=society&category=lawyer-charity',
          key__en: '',
          key__jp: '',
          label: '律師公益事務委員會',
          label__en: 'Public Interest Affairs Committee',
          label__jp: '弁護士公益事務委員会',
          children: [],
        },
        {
          key: '/public-service?group=society&category=labor-law',
          key__en: '',
          key__jp: '',
          label: '勞動法委員會',
          label__en: 'Labor Law Committee',
          label__jp: '労働法委員会',
          children: [],
        },
      ],
    },
    {
      key: '/public-service?group=subsidy',
      key__en: '',
      key__jp: '',
      label: '論文補助',
      label__en: 'Dissertation Scholarship',
      label__jp: '論文助成金',
      children: [],
    },
    {
      key: '',
      key__en: '',
      key__jp: '',
      label: '網域爭議名稱處理',
      label__en: 'Domain Name Dispute Resolution Committee',
      label__jp: 'ドメイン名紛争処理委員会',
      children: [
        {
          key: '/public-service?group=domain&category=manual',
          key__en: '',
          key__jp: '',
          label: '宣導手冊',
          label__en: 'Promotional Brochure',
          label__jp: '広報パンフレット',
          children: [],
        },
        {
          key: '/public-service?group=domain&category=rules',
          key__en: '',
          key__jp: '',
          label: '相關法規',
          label__en: 'Relevant Regulations',
          label__jp: '関連法規',
          children: [],
        },
        {
          key: '/public-service?group=domain&category=flow',
          key__en: '',
          key__jp: '',
          label: '流程說明',
          label__en: 'Process Description',
          label__jp: '手続説明',
          children: [],
        },
        {
          key: '/public-service?group=domain&category=expert',
          key__en: '',
          key__jp: '',
          label: '專家名單',
          label__en: 'List of experts',
          label__jp: '専門家リスト',
          children: [],
        },
        {
          key: '/public-service?group=domain&category=standard',
          key__en: '',
          key__jp: '',
          label: '費用標準',
          label__en: 'Fee Standards',
          label__jp: '料金表',
          children: [],
        },
        {
          key: '/public-service?group=domain&category=form',
          key__en: '',
          key__jp: '',
          label: '書狀表格',
          label__en: 'Forms',
          label__jp: '書面フォーム',
          children: [],
        },
        {
          key: '/public-service?group=domain&category=qa',
          key__en: '',
          key__jp: '',
          label: 'Q & A',
          label__en: 'Q & A',
          label__jp: 'Q & A',
          children: [],
        },
        {
          key: '/public-service?group=domain&category=announcement',
          key__en: '',
          key__jp: '',
          label: '爭議決定公告',
          label__en: 'Dispute Decision Announcement',
          label__jp: '紛争決定公告',
          children: [],
        },
      ],
    },
    {
      key: '/public-service?group=literature',
      key__en: '',
      key__jp: '',
      label: '法律文學',
      label__en: 'Legal Literature',
      label__jp: '法律文学',
      children: [],
    },
    {
      key: '/public-service?group=lecturer',
      key__en: '',
      key__jp: '',
      label: '上市櫃講師',
      label__en: 'Lecturers List-Listed Companies',
      label__jp: '上場会社等役員研修講師リスト',
      children: [],
    },
    {
      key: '/public-service?group=fraud',
      key__en: '',
      key__jp: '',
      label: '詐騙警報',
      label__en: 'Scam Alert',
      label__jp: '詐欺警報',
      children: [],
    },
    {
      key: '/public-service?group=report',
      key__en: '',
      key__jp: '',
      label: '倫理風紀專區',
      label__en: 'Ethics and Discipline Zone',
      label__jp: '倫理風紀',
      children: [],
    },
  ],
};

export const RoutesSpec = [AboutSpec, MemberSpec, LawSpec, PublicSpec];
